const filterList = {
    all: {
        name: 'All',
        dictKey: 'summary_all',
        type: 'all',
        hideIfEmpty: false
    }, scoringPlays: {
        name: 'Scoring',
        dictKey: 'summary_scoring',
        type: 'scoringPlays',
        hideIfEmpty: false
    }, highlights: {
        name: 'Highlights',
        dictKey: 'summary_highlights',
        type: 'highlights',
        hideIfEmpty: false
    }, keyMoments: {
        name: 'Key Moments',
        dictKey: 'summary_keyMoments',
        type: 'keyMoments',
        hideIfEmpty: true
    }, homeRuns: {
        name: 'Home Runs',
        dictKey: 'summary_homeRuns',
        type: 'homeRuns',
        hideIfEmpty: true
    }, strikeouts: {
        name: 'Strike Outs',
        dictKey: 'summary_strikeouts',
        type: 'strikeouts',
        hideIfEmpty: true
    }, hardHits: {
        name: 'Hard Hits',
        dictKey: 'summary_hardHits',
        type: 'hardHits',
        hideIfEmpty: true
    },
    // highLeverage: {
    //     name: 'High Leverage',
    //     dictKey: 'summary_highLeverage',
    //     type: 'highLeverage',
    //     hideIfEmpty: true
    // },
    leadChange: {
        name: 'Lead Change',
        dictKey: 'summary_leadChange',
        type: 'leadChange',
        hideIfEmpty: true
    }, winProb: {
        name: 'Win Prob',
        dictKey: 'summary_winProb',
        type: 'winProb',
        hideIfEmpty: true
    }
};

export default filterList;
